import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { IAvalua } from '../../dialog/avaluar/avaluar.interfaces';
import { APIURLConstantsService } from '../../services/api-url-service/apiurlconstants.service';

@Injectable()
export class ManageAvaluaService {

  private options: {
    headers?: HttpHeaders,
    observe?: 'body',
    params?: HttpParams,
    reportProgress?: boolean,
    responseType: any,
    withCredentials?: boolean
  };

  private _API_BASE_URL: string = environment['API_URL'];

  public get(codi: string): Observable<IAvalua> {
    return this.authHttp.get<any>(this._API_BASE_URL + 'avalua/' + codi)
      .pipe(map(response => response || []));
  }

  public update(codi: string, avalua: IAvalua, payload: IAvalua): Observable<IAvalua> {
    
    return this.authHttp.put<any>(this._API_BASE_URL + 'avalua/' + codi, payload)
      .pipe(map(response => response || []));
  }

  constructor(private authHttp: HttpClient) { }

}
